// Request type that carries IO/Campaign-Setup fields (requestTypeDetails). Single source of
// truth for the string used by the field registry and the read-only details view.
export const IO_REQUEST_TYPE = 'IO Request & Campaign Setup';

export const taskTypes = [
  'Display Campaign',
  IO_REQUEST_TYPE,
  'SEO',
  'SEM',
  'Attention Signals',
  'Demograph',
  'Onboarding',
  'Troubleshooting',
  'Sales Support',
  'General Question',
  'Bug Report',
  'Feature Request',
  'Admin Support',
  'OffBoarding',
  'Paid Social',
];

// Request types that operate on / reference an existing campaign — only these show the
// "Related Campaigns" linking section in the task form. Everything else (internal/account/
// support work, and IO which CREATES a campaign rather than linking one) hides it.
// Adjust this list to change which types surface the campaign picker.
export const campaignLinkedRequestTypes = [
  'Display Campaign',
  'SEO',
  'SEM',
  'Attention Signals',
  'Demograph',
  'Paid Social',
  'Troubleshooting',
  'Sales Support',
];

export const subTypes = {
  'Display Campaign': [
    'Update Campaign Name',
    'Update Creative(s)',
    'Update Clickthru URL(s)',
    'Update Audience Segment(s)',
    'Update Geotarget(s)',
    'Update Walk-in Location(s)',
    'Update E-Commerce Attribution',
    'Update Campaign Status',
    'Campaign Budget / Flight Dates',
    'Change Line Item Allocation / Change Flight Dates',
    'Campaign Launch',
    'Campaign Renewal',
    'Report Request',
    'Other',
  ],
  Onboarding: [
    'Domain Approval',
    'Org Creation',
    'Tag Creation / Installation',
    'Whitelabel',
    'Other',
  ],
  'Admin Support': ['Access', 'Processing'],
  Troubleshooting: ['Tag Investigation', 'Pacing', 'Performance', 'Other'],
  'Sales Support': ['Request Renewal', 'Budget & Strategy', 'Other'],
  'Bug Report': ['Major', 'Minor'],
  'Feature Request': ['New Feature', 'Enhancement'],
  // Add other subtypes as needed
};

export const statusTypes = {
  'Not Started': 'NOT_STARTED',
  Triaged: 'TRIAGED',
  'Ready for Review': 'READY',
  'In Progress': 'IN_PROGRESS',
  Blocked: 'BLOCKED',
  Dependency: 'DEPENDENCY',
  'On Hold': 'ON_HOLD',
  Completed: 'COMPLETED',
  Monitoring: 'MONITORING',
  Duplicate: 'DUPLICATE',
  'Input Required': 'INPUT_REQUIRED',
  'No Longer Needed': 'NO_LONGER_NEEDED',
};

// Shared cap for the long-form description fields (task details, project
// description). Deliberately generous so proposal briefs fit inline instead of
// being offloaded to a linked doc, while staying well inside what the API
// accepts for a single mutation.
export const DESCRIPTION_MAX_LENGTH = 20000;

export const DEFAULT_STATUSES = ['NOT_STARTED', 'READY', 'IN_PROGRESS'];

// Statuses that mean the task is closed — commenting on one prompts to re-open it.
export const CLOSED_STATUSES = [statusTypes.Completed];

// Enum value -> the label shown in the status pickers.
export const getStatusLabel = (status) =>
  Object.keys(statusTypes).find((label) => statusTypes[label] === status) || status;

export const RESELLER_LEVELS = ['CHANNEL_PARTNER', 'CHANNEL_PARTNER_DIRECT'];

export const advertiserTypes = {
  Platform: 'PLATFORM',
  'Channel Partner': 'CHANNEL_PARTNER',
  'Channel Partner Direct': 'CHANNEL_PARTNER_DIRECT',
};

export const urgencyTypes = {
  Low: 'LOW',
  Medium: 'MEDIUM',
  High: 'HIGH',
  Critical: 'CRITICAL',
};

export const urgencyColors = {
  [urgencyTypes.Low]: 'gray',
  [urgencyTypes.Medium]: 'yellow',
  [urgencyTypes.High]: 'orange',
  [urgencyTypes.Critical]: 'red',
};

// Hex urgency colors matching SCSS $urgency-* tokens — for inline styles (dots, badges)
export const urgencyHexColors = {
  LOW: '#22c55e',
  MEDIUM: '#eab308',
  HIGH: '#f97316',
  CRITICAL: '#dc2626',
};

export const allowedFileExtensions = [
  '.doc',
  '.docx',
  '.pdf',
  '.txt',
  '.xls',
  '.xlsx',
  '.ppt',
  '.pptx',
  '.csv',
  '.zip',
];

export const allowedImageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.avif'];

export const filterMenuColumnOptions = [
  { label: 'Following Tasks', value: 'following' },
  { label: 'Collaborating Tasks', value: 'collaborating' },
  // Add more columns as needed
];

export const SEARCH_FIELD_OPTIONS = [
  { label: 'Name', value: 'name' },
  { label: 'Description', value: 'description' },
  { label: 'Comments', value: 'comments' },
];
